module.exports = __webpack_public_path__ + "img/img-3-5.3517d727.png";